import React from 'react'
import { connect } from 'react-redux'
import { getFilteredSortedInvoices } from "selectors/invoices";
import { Card, Icon, Menu } from 'semantic-ui-react'

import { fetchEntities } from 'actions/entities';
import { fetchInvoicesGenerate } from 'actions/invoices';

import EntitiesList from 'components/entities/EntitiesList';
import InvoicesListItem from 'components/invoices/InvoicesListItem'
import InvoiceForm from 'components/invoices/InvoiceForm'

import dotProp from 'dot-prop'
import { getPersistedEntities } from "../../selectors/entities";
import CreateInvoiceForm from "./CreateInvoiceForm";

const mapStateToProps = (state, ownProps) => {
  const employments = getPersistedEntities('employment')(state, ownProps);
  const employmentOptions = employments.map((emp) => {
    return { key: emp.id, value: emp.id, text: emp.name }
  })
  const trueFalseOptions = (key) =>
    [{ key: true, value: true, text: I18n.t(`components.filters.${key}.true`)},
      { key: false, value: false, text: I18n.t(`components.filters.${key}.false`) }]

  const filters = [
    {by: 'name', getTarget: (invoice) => invoice.dossier?.patient && invoice.dossier.patient.firstName + ' ' + invoice.dossier.patient.lastName },
    {by: 'paid', selectOptions: trueFalseOptions('paid_options'), getTarget:(invoice) => [!!invoice.payedAt] },
    {by: 'proposed', selectOptions: trueFalseOptions('proposed_options'), getTarget:(invoice) => [invoice.proposed] }
  ]

  if (state.view === "admin") {
    filters.push({ by: 'employment', selectOptions: employmentOptions, getTarget: (invoice) => invoice.dossier?.responsibleIds || []})
  }


  return {
    entities: getFilteredSortedInvoices(state, filters),
    entityName: 'invoice',
    item: InvoicesListItem,
    form: CreateInvoiceForm,
    listComponent: Card.Group,
    loading: state.meta?.invoice?.loading,
    error: state.meta?.invoice?.error,
    totalPages: dotProp.get(state, 'meta.invoice.keyWindows.byWindow.list.totalPages'),
    activePage: dotProp.get(state, 'meta.invoice.keyWindows.byWindow.list.page'),
    filters: filters
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchExtraEntities: () => {
      dispatch(fetchEntities('invoices', { name: 'list', page: 1, append: true }))
    },
    onLoadMore: (activePage, totalPages) => {
      if( activePage < totalPages ) {
        dispatch(fetchEntities('invoices', { name: 'list', filter: {}, page: activePage + 1, append: true }))
      }
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EntitiesList);
